var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('intersect',{attrs:{"root-margin":"50px 0px 0px"},on:{"~enter":function($event){return _vm.mountFlickity($event)}}},[_c('div',{class:['flickity-carousel', { 'flickity-carousel--is-mounted': _vm.isMounted }]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }